module.exports = __webpack_public_path__ + "media/images/pages/home_featured/contributor-overview-focus-631dc815de341c8603d1a9f64bf3e3e4.png";